<h1 mat-dialog-title>Review Product Data Filenames</h1>
<mat-dialog-content>
  @if (isLoading) {
    <div style="display: flex; justify-content: center; padding: 24px">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  @if (!isLoading && result) {
    <div>
      <div class="convention-summary">
        <div class="convention-rows">
          <div class="convention-row">
            <span class="convention-label">Identifier:</span>
            <code class="convention-value">{{ result.convention.identifier.kind }}</code>
          </div>
          <div class="convention-row">
            <span class="convention-label">Extensions:</span>
            @for (extension of result.convention.extensions.enabled; track extension) {
              <code class="convention-value">{{ extension }}</code>
            }
          </div>
          <div class="convention-row">
            <span class="convention-label">Sample:</span>
            <code class="convention-value">{{ result.convention.sample.pattern }}</code>
          </div>
        </div>
        @if (canEditPdfc) {
          <button
            mat-stroked-button
            type="button"
            class="convention-edit"
            (click)="openEditPdfc()"
          >
            <mat-icon>edit</mat-icon>
            Edit convention
          </button>
        }
      </div>

      <div class="summary">
        <span><strong>Total filenames:</strong> {{ result.summary.totalFilenames }}</span>
        @if (result.summary.conventionMismatchCount > 0) {
          <span class="mismatch-warning">
            <mat-icon>warning</mat-icon>
            <strong>Convention mismatch:</strong> {{ result.summary.conventionMismatchCount }}
          </span>
        }
        @if (result.summary.cannotProceedCount > 0) {
          <span class="cannot-proceed-chip">
            <mat-icon>error</mat-icon>
            <strong>Cannot proceed:</strong> {{ result.summary.cannotProceedCount }}
          </span>
        }
      </div>

      @if (result.cannotProceed.length > 0) {
        <div class="cannot-proceed-banner">
          <mat-icon>error</mat-icon>
          <div>
            <strong>Cannot proceed:</strong>
            {{ result.cannotProceed.length }} product{{ result.cannotProceed.length === 1 ? '' : 's' }}
            missing the identifier configured by the current Product Data Filename Convention.
            Configure the missing identifier on each product, or update the convention, before
            creating the collection.
          </div>
        </div>
      }

      <table mat-table [dataSource]="result.rows" class="asset-table">
        <ng-container matColumnDef="product">
          <th mat-header-cell *matHeaderCellDef>Product ({{ result.convention.identifier.kind }})</th>
          <td mat-cell *matCellDef="let row" class="product-cell">
            {{ row.origin.product.identifiers.barcode
              || row.origin.product.identifiers.reference
              || row.origin.product.identifiers.description
              || row.origin.product.id }}
          </td>
        </ng-container>
        <ng-container matColumnDef="format">
          <th mat-header-cell *matHeaderCellDef>Format</th>
          <td mat-cell *matCellDef="let row">
            {{ row.origin.format.extension }}
          </td>
        </ng-container>
        <ng-container matColumnDef="generatedFilename">
          <th mat-header-cell *matHeaderCellDef>Generated Filename</th>
          <td mat-cell *matCellDef="let row" class="file-path">
            {{ row.filename.generated }}
          </td>
        </ng-container>
        <ng-container matColumnDef="conventionCurrent">
          <th mat-header-cell *matHeaderCellDef>Convention Current</th>
          <td mat-cell *matCellDef="let row">
            @if (row.filename.templateCurrent) {
              <mat-icon class="current-icon">check_circle</mat-icon>
            }
            @if (!row.filename.templateCurrent) {
              <mat-icon class="outdated-icon">warning</mat-icon>
            }
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>

      @if (result.cannotProceed.length > 0) {
        <div class="cannot-proceed-section">
          <h3 class="cannot-proceed-title">
            <mat-icon>error</mat-icon>
            Cannot proceed
          </h3>
          <table mat-table [dataSource]="result.cannotProceed" class="cannot-proceed-table">
            <ng-container matColumnDef="product">
              <th mat-header-cell *matHeaderCellDef>Product</th>
              <td mat-cell *matCellDef="let entry">
                {{ entry.product.identifiers.barcode
                  || entry.product.identifiers.reference
                  || entry.product.identifiers.description
                  || entry.product.id }}
              </td>
            </ng-container>
            <ng-container matColumnDef="reason">
              <th mat-header-cell *matHeaderCellDef>Reason</th>
              <td mat-cell *matCellDef="let entry">{{ entry.reason }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="cannotProceedColumns"></tr>
            <tr mat-row *matRowDef="let entry; columns: cannotProceedColumns"></tr>
          </table>
        </div>
      }
    </div>
  }

  @if (!isLoading && hasErrored) {
    <div class="load-error">
      <mat-icon color="warn">error</mat-icon>
      <span>Failed to load product data filenames preview.</span>
    </div>
  }
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-stroked-button mat-dialog-close>Close</button>
</mat-dialog-actions>
